function getByPath(source, path) {
    if (!source || !path) {
        return undefined;
    }

    return path.split('.').reduce((acc, key) => {
        if (acc == null) {
            return undefined;
        }
        return acc[key];
    }, source);
}

export function interpolateTemplate(template, values = {}, options = {}) {
    if (template == null) {
        return template;
    }

    const { fallback = '' } = options;
    const normalized = String(template);

    return normalized.replace(/\{\{\s*([^}]+)\s*\}\}/g, (_, tokenPath) => {
        const resolvedValue = getByPath(values, tokenPath.trim());
        if (resolvedValue == null || resolvedValue === '') {
            return fallback;
        }
        return String(resolvedValue);
    });
}

export function tokenizeTemplate(template, values = {}, options = {}) {
    const { fallback = '' } = options;
    const normalized = String(template ?? '');
    const regex = /\{\{\s*([^}]+)\s*\}\}/g;
    const tokens = [];
    let cursor = 0;
    let match;

    while ((match = regex.exec(normalized)) !== null) {
        const [fullMatch, tokenPathRaw] = match;
        const tokenPath = tokenPathRaw.trim();
        const start = match.index;
        const end = start + fullMatch.length;

        if (start > cursor) {
            tokens.push({
                type: 'text',
                key: `text-${cursor}`,
                value: normalized.slice(cursor, start),
            });
        }

        const resolvedValue = getByPath(values, tokenPath);
        tokens.push({
            type: 'token',
            key: `token-${start}`,
            tokenPath,
            value: resolvedValue == null || resolvedValue === '' ? fallback : String(resolvedValue),
        });

        cursor = end;
    }

    if (cursor < normalized.length) {
        tokens.push({
            type: 'text',
            key: `text-${cursor}`,
            value: normalized.slice(cursor),
        });
    }

    return tokens;
}
